/*
 * ─── ACTIVE THEME CONFIG ──────────────────────────────────────────────────
 *
 *  Change ACTIVE_THEME to switch the entire app theme.
 *
 *  Available themes:
 *    'slate-pro'     → Slate Pro     (white + blue + grey, premium) ← NEW
 *    'ocean-blue'    → Ocean Blue    (white + blue, light)
 *    'midnight-navy' → Midnight Navy (dark navy + blue, dark)
 *
 *  To add a new theme, see: src/theme/themeRegistry.js
 * ──────────────────────────────────────────────────────────────────────────
 */

export const ACTIVE_THEME = 'slate-pro';
